import { Layout } from 'antd';
import { useRouter } from 'next/router';
import Default, * as subLayouts from '../../layouts';
const MainLayout = ({
  subLayout,
  children
}) => {
  const router = useRouter();
  if (router.pathname.split('/').filter(Boolean).join('/') === 'gql') {
    return children;
  }
  const SubLayout = (() => {
    if ([null, undefined].includes(subLayout)) {
      return subLayouts[router.pathname.split('/').filter(Boolean)[0]] ?? Default;
    }
    if (subLayouts[subLayout]) {
      return subLayouts[subLayout];
    }
    throw new Error(`Undefined subLayout: ${subLayout}`);
  })();
  return <Layout style={{
    minHeight: '100vh'
  }} data-sentry-element="Layout" data-sentry-component="MainLayout" data-sentry-source-file="MainLayout.jsx">
      <SubLayout data-sentry-element="SubLayout" data-sentry-source-file="MainLayout.jsx">
        {children}
      </SubLayout>
    </Layout>;
};
export default MainLayout;